import { render, staticRenderFns } from "./PriceNum.vue?vue&type=template&id=3f843614&scoped=true"
import script from "./PriceNum.vue?vue&type=script&lang=js"
export * from "./PriceNum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f843614",
  null
  
)

export default component.exports